import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_flexcol _gap-6 _fd-r--m" }
const _hoisted_2 = { class: "gfu-1of1 gfu-6of12--m" }
const _hoisted_3 = { class: "gfu-content-head _mt-0" }
const _hoisted_4 = { class: "gfu-1of1 gfu-6of12--m" }
const _hoisted_5 = { class: "gfu-content-head _mt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_title = _resolveComponent("base-title")
  const _component_external_login_actions = _resolveComponent("external-login-actions")
  const _component_login_form = _resolveComponent("login-form")
  const _component_continue_as_guest_modal_form = _resolveComponent("continue-as-guest-modal-form")
  const _component_base_view = _resolveComponent("base-view")
  const _component_login_view = _resolveComponent("login-view")

  return ($setup.guestUserPledgeEnabled)
    ? (_openBlock(), _createBlock(_component_base_view, {
        key: 0,
        class: "gfu-layout-wrapper gfu-signing-page js-main-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_title, {
                  as: "h1",
                  "data-qa": "page-title"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Account.ContinueWithAnAccountHeader), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createVNode(_component_external_login_actions, {
                "return-url": $props.checkoutUrl,
                class: "_mb-3"
              }, null, 8 /* PROPS */, ["return-url"]),
              _createVNode(_component_login_form, {
                class: "gfu-box gfu-box--thick",
                "return-url": $props.checkoutUrl,
                "create-account-url": $props.createAccountUrl,
                onSuccess: $options.onLoginSuccess,
                onSignUp: $options.onSignUp,
                "data-qa": "login-form"
              }, null, 8 /* PROPS */, ["return-url", "create-account-url", "onSuccess", "onSignUp"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_title, {
                  as: "h2",
                  level: "h1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Resources.Account.ContinueAsGuestHeader), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _createVNode(_component_continue_as_guest_modal_form, { "action-url": $props.checkoutUrl }, null, 8 /* PROPS */, ["action-url"])
            ])
          ])
        ]),
        _: 1 /* STABLE */
      }))
    : (_openBlock(), _createBlock(_component_login_view, {
        key: 1,
        "return-url": $props.checkoutUrl
      }, null, 8 /* PROPS */, ["return-url"]))
}